import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom';
import useThunkReducer from './useThunkReducer';
import listReducer, { toggleListItem, addCreatedList, LISTS } from '../microapps/Community/ducks/lists';
import ListsModal from '../microapps/Community/components/modals/lists/ListsModal';
import { modalSignup } from '../utils/modal_funnel_util';

const useListItems = (initialLists, context) => {
  const [showModal, toggleShowModal] = useState(false);
  const [activeItem, setActiveItem] = useState({ type: null, id: null });
  const [state, dispatch] = useThunkReducer(listReducer, LISTS, initialLists, { context });

  const handleModalFavoriteClick = listId => {
    dispatch(toggleListItem(listId, activeItem.type, activeItem.ID));
  };

  const handleModalListCreated = newList => {
    dispatch(addCreatedList(newList));
  };

  const closeModal = () => {
    toggleShowModal(false);
    setActiveItem({ type: null, id: null });
  };

  const renderModal = () => {
    if (!showModal) {
      return;
    }

    return ReactDOM.createPortal(
      <ListsModal
        closeModal={closeModal}
        type={activeItem.type}
        ID={activeItem.ID}
        lists={state.lists}
        listItems={state.listItems}
        handleModalFavoriteClick={handleModalFavoriteClick}
        handleModalListCreated={handleModalListCreated}
      />,
      document.getElementById('modalPortal')
    );
  };

  const handleFavoriteClick = (type, ID) => {
    if (!context.currentUser) {
      return modalSignup(`${type}-resultcard-favorite`, window.location.pathname);
    }

    setActiveItem({ type, ID });
    toggleShowModal(true);
  };

  return useMemo(() => {
    return { handleFavoriteClick, listItems: state.listItems, renderModal };
  }, [state, showModal]);
};

export default useListItems;
